module.exports = __webpack_public_path__ + "static/media/ic_empty_dashboard.26a01fd9.svg";